"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Analytics_1 = require("./lib/Analytics");
exports.default = Analytics_1.default;
var Analytics_2 = require("./lib/Analytics");
exports.Analytics = Analytics_2.default;
var WebAnalytics_1 = require("./lib/WebAnalytics");
exports.WebAnalytics = WebAnalytics_1.default;
